import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {} from "@fortawesome/free-solid-svg-icons"
import '../styles/about.css';

class About extends Component {
  render() {
    return (
      <div className='about' id='about'>
        <div id='wrapper'>
          <div className='container' id='container'>
            <div className='aboutMe'>
              <h2>Frontend Developer</h2>
            </div>
            <div className='row'>
              <div class='col-lg-12 col-md-offset-1 col-sm-12'>
                <div class='about-right'>
                  <h5>
                    I am <span>Mukhammadali Shukhratov</span>. I am a simple ,
                    creative, enthusiastic , trustworthy and willing to take
                    responsibility person. I always like to create something to
                    help those who are not able to help themselves. You will
                    find me playing football when I am not coding.
                  </h5>
                  <br />
                  <h5>
                    I have vast experience in Javascript, React js, Redux,
                    Advanced Hooks and on.{' '}
                  </h5>

                  <h5>
                    You can refer to my github{' '}
                    <a href='https://github.com/m1172'> page</a> to see all the
                    projects I have been working on.
                    <a
                      href='https://drive.google.com/uc?export=download&id=1N9lCbwWzHLlS4kEeD8XUAR18ZtGr1Rf4'
                      target='_blank'
                    >
                      <button id='cv'>Dowload CV</button>
                    </a>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default About;
